//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app/shared.service';
import { CatPais, TipoUbicacion } from 'app/shared/enum.shared';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { zip,  } from 'rxjs';

//nueva interfas caracteristicas de input (hidden, disabled, etc)
interface CaracteristicasInput {
    hidden?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    required?: boolean;
    placeholder?: string;
}



@Component({
  selector: 'app-ubicaciones',
  templateUrl: './ubicaciones.component.html',
  styleUrls: ['./ubicaciones.component.scss']
})
export class UbicacionesComponent implements OnInit, OnChanges {
    //@OUTPUTS
    @Output() FormUbicacionEventEmiter = new EventEmitter<any>();
    @Output() AddressEmitter = new EventEmitter<any>();
    //@INPUTS
    @Input() idOperacion: any;
    @Input() title: any[];
    @Input() idUbicacion : any;
    @Input() changed: any;
    //Formularios
    spinner: boolean = false;
    rfcPattern = /^[A-Z]{4}[0-9]{6}[0-9A-Z]{2,3}/;
    ubicationPattern = /^(DE|OR)[0-9]{6}/;
    cpPattern = /^[0-9]{5}/;
    FormDomicilio =     new FormGroup({
       idOperacion: new FormControl(null),
        ubicacion:          new FormControl(null),
        nombreUbicacion:    new FormControl(null),
        tUbicacion:         new FormControl(null),
        idUbicacion:        new FormControl(null, [Validators.pattern(this.ubicationPattern)]),
        fhSalida:           new FormControl(null),
        distRecorrida:      new FormControl(null),
        rfcRemitente:       new FormControl(null,[Validators.required, Validators.pattern(this.rfcPattern)]),
        nombreRemitente:    new FormControl(null),
        numRegID:           new FormControl(null),
        residenciaFiscal:   new FormControl(null),
        navegacionTrafico:  new FormControl(null),
        tipoEstacion:       new FormControl(null),
        numEstacion:        new FormControl(null),
        pais:               new FormControl(null,[Validators.required]),
        cPostal:            new FormControl(null,[Validators.required, Validators.pattern(this.cpPattern)]),
        estado:             new FormControl(null,[Validators.required]),
        municipio:          new FormControl(null),
        localidad:          new FormControl(null),
        colonia:            new FormControl(null),
        calle:              new FormControl(null),
        numExt:             new FormControl(null),
        numInt:             new FormControl(null),
        referencia:         new FormControl(null),
    });
    codigoPostal;
    submitted = false;
    ubicaciones:   any[];
    tubicaciones: any;
    paises: [];
    estados: any[];
    municipios: any[];
    localidades:  any[];
    colonias: any[] = [];
    curDireccion: any;
    cp: number;

    // Variable NumReg con tipo CaracteristicasInput
    rulNumReg: CaracteristicasInput = {
        hidden: false,
        disabled: true,
        readonly: false,
        required: false,
        placeholder: 'Num. Reg. ID'
    };

    rulResidenciaFiscal: CaracteristicasInput = {
        disabled: true
    };

    rulTipoEstacion: CaracteristicasInput = {
        disabled: true
    };

    rulNumEstacion: CaracteristicasInput = {
        disabled: true
    };
    listRFCExtrangeros: any[] = ['XEXX010101000'];
    lstPaises: any;
    tipoTransporte: any;
    countUbica: number | boolean;
    tipoEstacion: any;
    navTrafico: any;
    dateText: string = 'Salida';
    rfcText: string = 'Remitente';
    nameText: string = 'Remitente';

    constructor(
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService,
        private sharedService: SharedService
    ) { }
    ngOnChanges(changes: SimpleChanges): void {
        if(changes?.changed) {
            this.SelUbicaciones();
        }
    }

    ngOnInit(): void {

        this.senddata();
        this.SelUbicaciones();
        this.seltUbicaciones();
        this.SelPaises();

        if( this.rulNumReg.disabled ){
            this.FormDomicilio.controls['numRegID'].disable();
        }

        if( this.rulResidenciaFiscal.disabled ){
            this.FormDomicilio.controls['residenciaFiscal'].disable();
        }

        if( this.rulTipoEstacion.disabled ){
            this.FormDomicilio.controls['tipoEstacion'].disable();
        }

        if( this.rulNumEstacion.disabled ){
            this.FormDomicilio.controls['numEstacion'].disable();
        }

        this.FormDomicilio.controls['navegacionTrafico'].disable();

        // this.selPaisesExtrangero()

        this.sharedService.tipoTransporte$.subscribe( (valores:any) => {
            this.tipoTransporte = (valores) ? valores : 1;
            if( valores == 1 || valores == null ){
                this.FormDomicilio.controls['tipoEstacion'].disable();
            }
            else{
                this.FormDomicilio.controls['tipoEstacion'].enable();
            }


            if( this.countUbica ){
                if( this.tipoTransporte != 1 ){
                    this.FormDomicilio.controls['numEstacion'].enable();
                }
                else{
                    this.FormDomicilio.controls['numEstacion'].disable();    
                }
            }
            else{
                this.FormDomicilio.controls['numEstacion'].disable();
            }
        });

        this.sharedService.countUbicaciones$.subscribe( (valores:boolean) => {
            this.countUbica = (valores) ? valores : false;
            if( valores ){
                if( this.tipoTransporte != 1 ){
                    this.FormDomicilio.controls['numEstacion'].enable();
                }
                else{
                    this.FormDomicilio.controls['numEstacion'].disable();    
                }
            }
            else{
                this.FormDomicilio.controls['numEstacion'].disable();
            }
        });

    }

    tipoUbicacionChange(value) {
        if (value == TipoUbicacion.Origen) {
            this.dateText = 'Salida';
            this.rfcText = 'Remitente';
            this.nameText = 'Remitente';
            this.FormDomicilio.controls.distRecorrida.disable();
            this.ubicationPattern = /^(OR)[0-9]{6}/;
            this.FormDomicilio.controls.idUbicacion.setValidators(Validators.pattern(this.ubicationPattern));
        } else {
            this.dateText = 'Llegada';
            this.rfcText = 'Destinatario';
            this.nameText = 'Destinatario';
            this.FormDomicilio.controls.distRecorrida.enable();
            this.ubicationPattern = /^(DE)[0-9]{6}/;
            this.FormDomicilio.controls.idUbicacion.setValidators(Validators.pattern(this.ubicationPattern));
        }
    }

    validaRFC(){


        // validar con indexof en este arreglo this.listRFCExtrangeros
        if( this.listRFCExtrangeros.indexOf(this.FormDomicilio.controls['rfcRemitente'].value) >= 0 ){
            this.rulNumReg.disabled = false;
            this.rulResidenciaFiscal.disabled = false;
            
            this.FormDomicilio.controls['numRegID'].enable();
            this.FormDomicilio.controls['residenciaFiscal'].enable();
            
        }else{
            this.rulNumReg.disabled = true;
            this.rulResidenciaFiscal.disabled = true;
            
            this.FormDomicilio.controls['numRegID'].disable();
            this.FormDomicilio.controls['residenciaFiscal'].disable();
            
        }
    
        
    }

    selPaisesExtrangero(){
        let data;
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.postService('catalogo/PostSelTipoFiguras',data).subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.lstPaises = res.recordsets[1];
                    this.store.dispatch(OcultarSpinner());
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    get FormDomicilioControl() {
        return this.FormDomicilio.controls;
    }

    saveDomicilio(){
        this.submitted = true;
        this.FormDomicilio.markAllAsTouched();
        if(this.FormDomicilio.valid){
            this.FormDomicilio.value.idOperacion = this.idOperacion;
            let data = {
                data: {
                    nombre: this.FormDomicilio.controls.nombreUbicacion.value,
                    fechaOperacion: this.FormDomicilio.controls.fhSalida.value + ':00',
                    distanciaRecorrida: this.FormDomicilio.controls.distRecorrida.value,
                    rfcAsociado: this.FormDomicilio.controls.rfcRemitente.value,
                    nombreAsociado: this.FormDomicilio.controls.nombreRemitente.value,
                    referencia: this.FormDomicilio.controls.referencia.value,
                    idUbicacion: this.FormDomicilio.controls.idUbicacion.value,
                    NumRegIdTrib: this.FormDomicilio.controls.numRegID.value,
                    residenciaFiscal: this.FormDomicilio.controls.pais.value,
                    cat_navegacion_trafico: this.FormDomicilio.controls.navegacionTrafico.value,
                    cat_tipo_estacion: this.FormDomicilio.controls.tipoEstacion.value,
                    numEstacion: this.FormDomicilio.controls.numEstacion.value,
                    cat_tipo_ubicacion: this.FormDomicilio.controls.tUbicacion.value,
                    dir_pai: this.FormDomicilio.controls.pais.value,
                    codigoPostal: this.FormDomicilio.controls.cPostal.value,
                    dir_estado: this.FormDomicilio.controls.estado.value,
                    dir_municipio: this.FormDomicilio.controls.municipio.value,
                    dir_localidad: this.FormDomicilio.controls.localidad.value,
                    dir_asentamiento: this.FormDomicilio.controls.colonia.value,
                    dir_codigo_postal: this.cp,
                    calle: this.FormDomicilio.controls.calle.value,
                    noExterior: this.FormDomicilio.controls.numExt.value,
                    noInterior: this.FormDomicilio.controls.numInt.value,
                    estado: this.FormDomicilio.controls.pais.value == CatPais.Mexico.toString() ? '' : this.estados.find((x: any) => x.id == this.FormDomicilio.controls.estado.value)?.nombre,
                    municipio: this.FormDomicilio.controls.pais.value == CatPais.Mexico.toString() ? '' : this.municipios.find((x: any) => x.id == this.FormDomicilio.controls.municipio.value)?.nombre,
                    localidad: this.FormDomicilio.controls.pais.value == CatPais.Mexico.toString() ? '' : this.localidades.find((x: any) => x.id == this.FormDomicilio.controls.localidad.value)?.nombre,
                    colonia: this.FormDomicilio.controls.pais.value == CatPais.Mexico.toString() ? '' : this.colonias.find((x: any) => x.id == this.FormDomicilio.controls.colonia.value)?.nombre
                }
            }
            this.store.dispatch(MostrarSpinner());

            if (this.FormDomicilio.controls.ubicacion.value) {
                this.srvcoal.putService(`fac-porte-direcciones/${this.FormDomicilio.controls.ubicacion.value}`, data).subscribe(
                    (res: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this.AddressEmitter.emit(res);
                        this._snackBar.open('Dirección actualizada correctamente', "OK", {duration: 5000});
                    }, (error: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this._snackBar.open(`Ocurrió un error al guardar la dirección ${error?.error?.error?.message}`, "OK", {duration:5000});
                    }
                )
            } else {
                this.srvcoal.postService('fac-porte-direcciones', data).subscribe(
                    (res: any) => {
                        this.srvcoal.putService(`ope-empresas/${this.idOperacion}`, {
                            data: {
                                fac_porte_direcciones: {
                                    connect: [res.data?.id]
                                }
                            }
                        }).subscribe((por: any) => {
                            // this.SelUbicaciones();
                            this.store.dispatch(OcultarSpinner());
                            this.AddressEmitter.emit(res);
                            this._snackBar.open("Dirección guardada correctamente", "OK", {duration:5000});
                        }, (error: any) => {
                            this.store.dispatch(OcultarSpinner());
                            this._snackBar.open(`Ocurrió un error al guardar la dirección ${error?.error?.error?.message}`, "OK", {duration:5000});
                        });
                    }, (error: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this._snackBar.open(`Ocurrió un error al guardar la dirección ${error?.error?.error?.message}`, "OK", {duration:5000});
                    }
                )
            }
            // this.srvcoal.postService('catalogo/PostInsDireccion',this.FormDomicilio.value).subscribe((res: any) => {
            //     if (res.err) {
            //         this.store.dispatch(
            //             MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
            //         );
            //     } else if (res.excepcion) {
            //         this.store.dispatch(
            //             MostrarExcepcion({
            //                 pila: res.excepcion,
            //                 tipoExcepcion: 3,
            //             })
            //         );
            //     } else {
            //         this.SelUbicaciones();
            //         this.idUbicacion = res.recordsets[0][0].idDireccion;
            //         return this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });
            //     }
            // },
            // (error: any) => {
            //     this.store.dispatch(
            //         MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
            // );
            // this.store.dispatch(OcultarSpinner());
            // });
        }
    }

    deleteDomicilio(){
        // let data = {
        //     iddireccion : this.idUbicacion
        // }
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.deleteService('fac-porte-direcciones/', this.FormDomicilio.controls.ubicacion.value)
        .subscribe((res: any) => {
            this.SelUbicaciones();
            this.FormDomicilio.reset();
            this.store.dispatch(OcultarSpinner());
            this.AddressEmitter.emit(res);
            this._snackBar.open("Se eliminó correctamente la dirección", "OK", {duration: 5000});
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this._snackBar.open(`Ocurrió un error al eliminar la dirección. ${error?.error}`, "OK", {duration: 18000});
        })
        // this.srvcoal.postService('catalogo/PostDelDireccion',data).subscribe((res: any) => {
        //     if (res.err) {
        //         this.store.dispatch(
        //             MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
        //         );
        //     } else if (res.excepcion) {
        //         this.store.dispatch(
        //             MostrarExcepcion({
        //                 pila: res.excepcion,
        //                 tipoExcepcion: 3,
        //             })
        //         );
        //     } else {
        //         this.SelUbicaciones();
        //         this.FormDomicilio.reset();
        //         return this._snackBar.open("Eliminacion Exitosa", 'Ok', { duration: 10000 });
        //     }
        // },
        // (error: any) => {
        //     this.store.dispatch(
        //         MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        // );
        // this.store.dispatch(OcultarSpinner());
        // });
    }

    SelUbicaciones(){
        let ope ={
            idOperacion : this.idOperacion
        }
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`ope-empresas?filters[id]=${this.idOperacion}&populate[fac_porte_direcciones][populate]=*`)
        .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.ubicaciones = [{
                id: 0,
                attributes: {
                    nombre: 'Agregue nueva dirección'
                }
            }];
            this.ubicaciones = this.ubicaciones.concat(res.data[0].attributes?.fac_porte_direcciones?.data
                .sort((a,b) => new Date(b.attributes?.updatedAt).getTime()-new Date(a.attributes?.updatedAt).getTime()));
            this.ubicaciones.length > 1 ? 
                (this.asingDireccion(this.ubicaciones[1].id), this.FormDomicilio.controls.ubicacion.setValue(this.ubicaciones[1].id) ): '';
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this._snackBar.open("Ocurrió un error al obtener las direcciones guardadas", "OK", {duration: 5000});
        })
        // this.srvcoal.postService('catalogo/PostSelDireccion',ope).subscribe((res: any) => {
        //     if (res.err) {
        //         this.store.dispatch(
        //             MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
        //         );
        //     } else if (res.excepcion) {
        //         this.store.dispatch(
        //             MostrarExcepcion({
        //                 pila: res.excepcion,
        //                 tipoExcepcion: 3,
        //             })
        //         );
        //     } else {
        //         this.ubicaciones = res.recordsets[0];
        //         if(this.idUbicacion){
        //             for (let i = 0; i <= this.ubicaciones.length-1; i++) {
        //                 var ubicacion = this.ubicaciones[i].idDireccion;
        //                 if(ubicacion == this.idUbicacion){
        //                     this.FormDomicilio.controls.ubicacion.setValue(this.ubicaciones[i]);
        //                     this.asingDireccion(this.ubicaciones[i]);
        //                     break;
        //                 }

        //             }

        //         }
        //     }
        // },
        // (error: any) => {
        //     this.store.dispatch(
        //         MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        // );
        // this.store.dispatch(OcultarSpinner());
        // });
    }

    seltUbicaciones(){
        this.store.dispatch(MostrarSpinner());
        zip(
            this.srvcoal.getService('cat-tipo-ubicacions'),
            this.srvcoal.getService('cat-tipo-estacions'),
            this.srvcoal.getService('cat-navegacion-traficos')
        ).subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.tubicaciones = res[0]?.data;

                // this.listRFCExtrangeros = [];
                // res.recordsets[1].forEach((params:any) => {
                //     this.listRFCExtrangeros.push( params.valor )
                // });

                this.tipoEstacion = res[1]?.data;
                this.navTrafico = res[2]?.data;
                this.FormDomicilio.controls.tUbicacion.setValue("180");

            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
            }
        )
        // this.srvcoal.postService('catalogo/PostSelTubicaciones').subscribe((res: any) => {
        //     if (res.err) {
        //         this.store.dispatch(
        //             MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
        //         );
        //     } else if (res.excepcion) {
        //         this.store.dispatch(
        //             MostrarExcepcion({
        //                 pila: res.excepcion,
        //                 tipoExcepcion: 3,
        //             })
        //         );
        //     } else {
        //         this.tubicaciones = res.recordsets[0];
                
        //         this.listRFCExtrangeros = [];
        //         res.recordsets[1].forEach((params:any) => {
        //             this.listRFCExtrangeros.push( params.valor )
        //         });

        //         this.tipoEstacion   = res.recordsets[2];
        //         this.navTrafico     = res.recordsets[3];
                
        //         this.FormDomicilio.controls.tUbicacion.setValue("180");
        //     }
        // },
        // (error: any) => {
        //     this.store.dispatch(
        //         MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        // );
    //     this.store.dispatch(OcultarSpinner());
    // });
    }

    asingDireccion(val){
        if(val == 0) {
            this.FormDomicilio.reset();
            this.FormDomicilio.markAsUntouched();
            this.submitted = false;
        } else {
            let value = this.ubicaciones.find(x => x.id == val)?.attributes;
            this.curDireccion = value;
            //Datos basicos direccion
            this.FormDomicilio.controls.cPostal.setValue(value.codigoPostal);
            this.verificaCP();
            this.FormDomicilio.controls.calle.setValue(value.calle);
            this.FormDomicilio.controls.numExt.setValue(value.noExterior);
            this.FormDomicilio.controls.numInt.setValue(value.noInterior);

            //Form extra
            this.FormDomicilio.controls.nombreUbicacion.setValue(value.nombre);
            this.FormDomicilio.controls.tUbicacion.setValue(value.cat_tipo_ubicacion?.data?.id);
            this.FormDomicilio.controls.idUbicacion.setValue(value.idUbicacion);
            this.FormDomicilio.controls.fhSalida.setValue(value.fechaOperacion?.substring(0,16));
            this.FormDomicilio.controls.distRecorrida.setValue(value.distanciaRecorrida);
            this.FormDomicilio.controls.rfcRemitente.setValue(value.rfcAsociado);
            this.FormDomicilio.controls.nombreRemitente.setValue(value.nombreAsociado);
            this.FormDomicilio.controls.numRegID.setValue(value.NumRegIdTrib);
            this.FormDomicilio.controls.residenciaFiscal.setValue(value.residenciaFiscal?.data?.id);
            this.FormDomicilio.controls.navegacionTrafico.setValue(value.cat_navegacion_trafico?.data?.id);
            this.FormDomicilio.controls.tipoEstacion.setValue(value.cat_tipo_estacion?.data?.id);
            this.FormDomicilio.controls.numEstacion.setValue(value.numEstacion);
            this.FormDomicilio.controls.referencia.setValue(value.referencia);
            //Se guarda la direccion seleccionada
            this.idUbicacion = value.idUbicacion;
        }
    }
    //Consulta de catalogos
    SelPaises(){
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`dir-paises?pagination[start]=0&pagination[limit]=54000`).subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.paises = res.data;
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            }
        )
            // this.srvcoal.getService('catalogo/GetPais').subscribe((res: any) => {
            //         if (res.err) {
            //             this.store.dispatch(
            //                 MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
            //             );
            //         } else if (res.excepcion) {
            //             this.store.dispatch(
            //                 MostrarExcepcion({
            //                     pila: res.excepcion,
            //                     tipoExcepcion: 3,
            //                 })
            //             );
            //         } else {
            //             this.paises = res.recordsets[0];
            //         }
            //     },
            //     (error: any) => {
            //         this.store.dispatch(
            //             MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
            //     );
            //     this.store.dispatch(OcultarSpinner());
            // });
    }

    SelEstados(value){
        value == CatPais.Mexico ? this.FormDomicilio.controls.tipoEstacion.enable() : this.FormDomicilio.controls.tipoEstacion.disable();
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`dir-estados?filters[dir_pai]=${value}`).subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.estados = res.data;
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
            }
        )
        // this.srvcoal.getService(`catalogo/GetEstado?idPais=${value}`).subscribe(
        //     (res: any) => {
        //         if (res.err) {
        //             this.store.dispatch(
        //                 MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
        //             );
        //         } else if (res.excepcion) {
        //             this.store.dispatch(
        //                 MostrarExcepcion({
        //                     pila: res.excepcion,
        //                     tipoExcepcion: 3,
        //                 })
        //             );
        //         } else {
        //             this.estados = res.recordsets[0];
        //             this.store.dispatch(OcultarSpinner());
        //         }
        //     },
        //     (error: any) => {
        //         this.store.dispatch(
        //             MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        //         );
        //         this.store.dispatch(OcultarSpinner());
        //     }
        // );
    }

    selMunicipios(value){
        let idPais = this.FormDomicilio.controls.pais.value;
        let entidad = value;
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`dir-municipios?filters[dir_estado]=${value}&pagination[start]=0&pagination[limit]=54000`)
        .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.municipios = res.data;
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
        })
        // this.srvcoal
        //     .getService(
        //         `catalogo/GetMunicipio?idPais=${idPais}&idEstado=${entidad}`
        //     )
        //     .subscribe(
        //         (res: any) => {
        //             if (res.err) {
        //                 this.store.dispatch(
        //                     MostrarExcepcion({
        //                         pila: res.error,
        //                         tipoExcepcion: 4,
        //                     })
        //                 );
        //             } else if (res.excepcion) {
        //                 this.store.dispatch(
        //                     MostrarExcepcion({
        //                         pila: res.excepcion,
        //                         tipoExcepcion: 3,
        //                     })
        //                 );
        //             } else {
        //                 this.municipios = res.recordsets[0];
        //                 this.store.dispatch(OcultarSpinner());
        //             }
        //         },
        //         (error: any) => {
        //             this.store.dispatch(
        //                 MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        //             );
        //             this.store.dispatch(OcultarSpinner());
        //         }
        //     );
    }

    selLocalidades(value){
        let idPais = this.FormDomicilio.controls.pais.value;
        let entidad = this.FormDomicilio.controls.estado.value;
        let municipio = value;
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;
        this.srvcoal.getService(`dir-asentamientos?filters[dir_municipio]=${value}&pagination[start]=0&pagination[limit]=54000`)
        .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.localidades = res.data;
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());

        })
        // this.srvcoal
        //     .getService(
        //         `catalogo/GetAsentamiento?idPais=${idPais}&idEstado=${entidad}&idMunicipio=${municipio}`
        //     )
        //     .subscribe(
        //         (res: any) => {
        //             if (res.err) {
        //                 this.store.dispatch(
        //                     MostrarExcepcion({
        //                         pila: res.error,
        //                         tipoExcepcion: 4,
        //                     })
        //                 );
        //             } else if (res.excepcion) {
        //                 this.store.dispatch(
        //                     MostrarExcepcion({
        //                         pila: res.excepcion,
        //                         tipoExcepcion: 3,
        //                     })
        //                 );
        //             } else {
        //                 this.localidades = res.recordsets[0];
        //                 this.colonias = res.recordsets[1];
        //                 this.store.dispatch(OcultarSpinner());
        //                 this.spinner = false;
        //             }
        //         },
        //         (error: any) => {
        //             this.store.dispatch(
        //                 MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
        //             );
        //             this.store.dispatch(OcultarSpinner());
        //             this.spinner = false;
        //         }
        //     );
    }

    selColonias(value){
        let idPais = this.FormDomicilio.controls.pais.value;
        let entidad = this.FormDomicilio.controls.estado.value;
        let municipio = this.FormDomicilio.controls.municipio.value;
        let colonia = value;
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;
        this.srvcoal
            .getService(
                `catalogo/GetCP?idPais=${idPais}&idEstado=${entidad}&idMunicipio=${municipio}&idAsentamiento=${colonia}`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.codigoPostal = res.recordsets[0][0].CP;
                        //console.log(res.recordsets[0][0].CP)
                        this.FormDomicilio.controls['cPostal'].setValue(this.codigoPostal);
                        this.store.dispatch(OcultarSpinner());
                        // this.spinner = false;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }
            );
    }

    verificaCP(){
        if(this.FormDomicilio.controls.cPostal.valid){
            this.consultarCP();
        }
    }

    consultarCP() {
        if (this.FormDomicilio.controls.cPostal.value === null)
            return this._snackBar.open("Ingrese un CP", 'Ok', { duration: 10000 });
        let CP = this.FormDomicilio.controls.cPostal.value;
        if (this.FormDomicilio.controls.cPostal.valid === false) {
            this._snackBar.open('Verifique el código postal', 'ok', {
                duration: 3000,
            });
        } else {
            this.store.dispatch(MostrarSpinner());
            this.spinner = true;
            this.srvcoal.getService(`dir-codigos-postales?filters[cp]=${this.FormDomicilio.value.cPostal}&populate[0]=dir_asentamiento.dir_municipio.dir_estado.dir_pai`)
            .subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                if (res.data[0]?.id) {
                    this.cp = res.data[0]?.id;
                    this.FormDomicilio.controls.pais.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.attributes?.dir_estado?.data?.attributes?.dir_pai?.data?.id);
                    this.FormDomicilio.controls.estado.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.attributes?.dir_estado?.data?.id);
                    this.FormDomicilio.controls.municipio.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.id);
                    this.FormDomicilio.controls.localidad.setValue(res.data[0]?.attributes?.dir_asentamiento?.data?.id);
                    this.FormDomicilio.controls.pais.disable();
                    this.FormDomicilio.controls.estado.disable();
                    this.FormDomicilio.controls.municipio.disable();
                    this.FormDomicilio.controls.localidad.disable();
                    this.SelEstados(this.FormDomicilio.controls.pais.value);
                    this.selMunicipios(this.FormDomicilio.controls.estado.value);
                    this.selLocalidades(this.FormDomicilio.controls.municipio.value);
                } else {
                    this._snackBar.open(
                        'No se encontraron coincidencias con ese CP.',
                        'OK',
                        { duration: 2500}
                    )
                }
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
            })
            // this.srvcoal.getService(`catalogo/GetCP_Origen?CP=${CP}`).subscribe(
            //     (res: any) => {
            //         if (res.err) {
            //             this.store.dispatch(
            //                 MostrarExcepcion({
            //                     pila: res.error,
            //                     tipoExcepcion: 4,
            //                 })
            //             );
            //         } else if (res.excepcion) {
            //             this.store.dispatch(
            //                 MostrarExcepcion({
            //                     pila: res.excepcion,
            //                     tipoExcepcion: 3,
            //                 })
            //             );
            //         } else {
            //             let exito = res.recordsets[0][0].mensaje;
            //             if (exito == 'Éxito') {
            //                 let origen = res.recordsets[0];
            //                 this.SelPaises();
            //                 this.FormDomicilio.controls.pais.setValue(
            //                     origen[0].idPais
            //                 );
            //                 this.SelEstados(origen[0].idPais);
            //                 this.FormDomicilio.controls.estado.setValue(
            //                     origen[0].idEstado
            //                 );
            //                 this.selMunicipios(origen[0].idEstado);
            //                 this.FormDomicilio.controls.municipio.setValue(
            //                     origen[0].idMunicipio
            //                 );
            //                 this.selLocalidades(origen[0].idMunicipio);
            //                 this.FormDomicilio.controls.colonia.setValue(
            //                     this.curDireccion.colonia
            //                 );
            //                 this.FormDomicilio.controls.localidad.setValue(
            //                     this.curDireccion.localidad
            //                 );
            //             } else {
            //                 this._snackBar.open(exito, 'OK', {
            //                     duration: 3000,
            //                 });
            //             }
            //             this.store.dispatch(OcultarSpinner());
            //             this.spinner = false;
            //         }
            //     },
            //     (error: any) => {
            //         this.store.dispatch(
            //             MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
            //         );
            //         this.store.dispatch(OcultarSpinner());
            //         this.spinner = false;
            //     }
            // );
        }
    }
    //Envio datos de formulario
    senddata(){
        this.FormDomicilio.statusChanges.subscribe(status => {
            if(this.FormDomicilio.valid){
                let data = {idubicacion : this.idUbicacion,title : this.title}
                this.FormUbicacionEventEmiter.emit(data);
            }
        });
    }
}
